import { useSearchParams } from "react-router";
import Success from "./Success";
import Failed from "./Failed";

const InstallmentVerifyCallbackPage = () => {
  const [searchparams] = useSearchParams();
  const success = searchparams.get("success")?.toLocaleLowerCase() === "true";

  if (success) {
    return <Success />;
  }
  return <Failed />;
};

export default InstallmentVerifyCallbackPage;
